/**
 * Google Maps configuration file
 * This is a free version that doesn't require an API key
 * Showing a default location in Hong Kong
 */

export const mapsConfig = {
  apiKey: '',
  defaultCenter: {
    lat: 22.365,
    lng: 114.131 // New Town Plaza, Kwai Fong, Hong Kong coordinates
  },
  defaultZoom: 16
}; 